import React, { useContext, useState } from 'react';
import { Divider, Form, Switch, Radio } from 'antd';
import { useLocalStorage } from 'react-use';
import { STORAGE_KEY_POS_UI_CONFIG } from '@/utils/storage';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { PosUIConfig } from '@/models/pos';
import { POSConfigContext } from '@/components/LayoutPOS';
import UIPreview from './preview';
import ClickInputNumber from '@/components/ClickInputNumber';
import PosButton from '@/components/PosButton';
import { playSound } from '@/utils/sound';
import { Custom_Display_Image } from '@/utils/uiHelper';

export const DEFAULT_POS_UI_CONFIG = {
  coGoodsShowImg: true,
  coShowCateIcon: true,
  coGoodsNameLines: 1,
  coGoodsItemsRow: 4,
  coGoodsImgHeight: 130,
  coGoodsImgMode: 'cover',
  coSkuAreaDisplayMode: 'vertical',
} as PosUIConfig;

const formLayout = {
  labelCol: { span: 6 },
  labelAlign: 'right' as 'right',
  wrapperCol: { span: 18 },
};
const UISettings: React.FC = () => {
  const [showPreview, setShowPreview] = useState(false);
  const { updateConfig } = useContext(POSConfigContext);
  const [form] = Form.useForm();
  const [config, setConfig] = useLocalStorage<PosUIConfig>(
    STORAGE_KEY_POS_UI_CONFIG,
    DEFAULT_POS_UI_CONFIG
  );

  const onSubmit = config => {
    const newConfig = Object.assign(config, config);
    setConfig(newConfig);
    updateConfig({ type: 'UPDATE_UI', payload: newConfig });
  };

  return (
    <Form<PosUIConfig>
      form={form}
      initialValues={config}
      onFinish={onSubmit}
      preserve
      onValuesChange={fields => {
        // if (fields.hasOwnProperty('consumerDisplayImg')) {
        //   window.__POS_Device__.setConsumerDisplayImage(fields.consumerDisplayImg);
        // }
        form.submit();
      }}>
      {/* <Divider orientation={'left'}>副屏</Divider>
      <div>
        <Form.Item label={'展示内容'} name={'consumerDisplayImg'} {...formLayout}>
          <Radio.Group
            onChange={() => {
              playSound('click');
            }}>
            <Radio.Button value={Custom_Display_Image.PRICE}>价目表</Radio.Button>
            <Radio.Button value="">企微名片</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </div> */}

      <Divider orientation={'left'}>收银台</Divider>
      <div>
        <Form.Item label={'一行展示商品数'} name={'coGoodsItemsRow'} {...formLayout}>
          <ClickInputNumber min={1} max={8} />
        </Form.Item>
        <Form.Item label={'商品名称显示行数'} name={'coGoodsNameLines'} {...formLayout}>
          <ClickInputNumber min={1} max={8} />
        </Form.Item>
        <Form.Item
          label={'品类图标显示'}
          name={'coShowCateIcon'}
          valuePropName={'checked'}
          {...formLayout}>
          <Switch
            onClick={() => {
              playSound('click');
            }}
            checkedChildren={
              <>
                <CheckOutlined /> 显示
              </>
            }
            unCheckedChildren={
              <>
                <CloseOutlined /> 不显示
              </>
            }
          />
        </Form.Item>
        <Form.Item
          label={'商品图片显示'}
          name={'coGoodsShowImg'}
          valuePropName={'checked'}
          {...formLayout}>
          <Switch
            onClick={() => {
              playSound('click');
            }}
            checkedChildren={
              <>
                <CheckOutlined /> 显示
              </>
            }
            unCheckedChildren={
              <>
                <CloseOutlined /> 不显示
              </>
            }
          />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.coGoodsShowImg !== cur.coGoodsShowImg}>
          {({ getFieldValue }) => {
            const showImg = getFieldValue('coGoodsShowImg');
            if (showImg) {
              return (
                <>
                  <Form.Item label={'商品图片高度'} name={'coGoodsImgHeight'} {...formLayout}>
                    <ClickInputNumber min={20} max={300} manualInput={true} />
                  </Form.Item>
                  <Form.Item label={'商品图片显示模式'} name={'coGoodsImgMode'} {...formLayout}>
                    <Radio.Group
                      onChange={() => {
                        playSound('click');
                      }}>
                      <Radio.Button value="cover">裁切铺满</Radio.Button>
                      <Radio.Button value="contain">宽高适应</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </>
              );
            }
          }}
        </Form.Item>
        <Form.Item name={'coSkuAreaDisplayMode'} label={'布局类型'} {...formLayout}>
          <Radio.Group
            onChange={() => {
              playSound('click');
            }}>
            <Radio.Button value="vertical">上下结构</Radio.Button>
            <Radio.Button value="horizontal">左右结构</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item label={'预览'} {...formLayout}>
          {showPreview ? (
            <UIPreview />
          ) : (
            <PosButton
              onClick={() => {
                setShowPreview(true);
              }}>
              点击查看预览
            </PosButton>
          )}
        </Form.Item>
      </div>
    </Form>
  );
};

export default UISettings;
